module.exports = __webpack_public_path__ + "static/media/gds_partnership.202cfc91.png";